// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination__container__Ra_Jo"};